import { render, staticRenderFns } from "./serverChange.vue?vue&type=template&id=5bae65d2&scoped=true&"
import script from "./serverChange.vue?vue&type=script&lang=js&"
export * from "./serverChange.vue?vue&type=script&lang=js&"
import style0 from "./serverChange.vue?vue&type=style&index=0&id=5bae65d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bae65d2",
  null
  
)

export default component.exports